module.exports = __webpack_public_path__ + "static/vr-3-1-9681b4eeb46f42560192e761e71120e4.jpeg";